import * as React from 'react'
import {useSafeCallback, unCallbackFn} from '@freckle/react-hooks'
import {ButtonAsync} from '@frontrow/console/src/components/button-async'
import {Alert} from '@frontrow/console/src/components/ui/alert'
import {exhaustive} from '@freckle/exhaustive'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSync} from '@fortawesome/free-solid-svg-icons'

import {postSchoolProvision} from '@frontrow/console/src/helpers/api-schools'

type Props = {
  clientId: string
}

type StatusT = 'initial' | 'awaiting_response' | 'failed' | 'success'

const defaultState: StatusT = 'initial'

function SyncUpdatesButton(props: Props): React.ReactElement {
  const {clientId} = props
  const [status, setStatus] = React.useState<StatusT>(defaultState)

  const onClick = useSafeCallback(
    () => (): Promise<void> => {
      setStatus('awaiting_response')

      return postSchoolProvision(clientId)
        .then(() => {
          setStatus('success')
        })
        .catch(() => {
          setStatus('failed')
        })
    },
    [clientId]
  )

  const alert = getAlert(status)

  return (
    <div className="flex flex-col items-start gap-2 [&_button_svg]:mr-2">
      <ButtonAsync title="Sync with current data" onClick={unCallbackFn(onClick)}>
        <FontAwesomeIcon icon={faSync} /> Sync with current data
      </ButtonAsync>
      {alert}
    </div>
  )
}

function getAlert(status: StatusT): React.ReactElement {
  switch (status) {
    case 'initial':
    case 'awaiting_response':
      return <></>
    case 'failed':
      return <Alert type="warning">Failed to enqueue job to fetch client data.</Alert>
    case 'success':
      return (
        <Alert type="success">
          Updating licenses & configuration data for all schools in this client. Please check back
          in 3-5 minutes.
        </Alert>
      )
    default:
      return exhaustive(status)
  }
}

export {SyncUpdatesButton}
